<template>
  <div class="tab-container">
    <div class="tabs">
      <div
        v-for="(item, index) in tabs"
        :key="index"
        :class="{ tab: true, active: activeIndex === index }"
        @click="changeTab(index)"
      >
        {{ handleTabName(item.typeName) }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tabs: {
      type: Array,
      require: true,
      default: () => []
    },
    activeIndex: {
      default: 0,
      type: Number
    }
  },

  methods: {
    changeTab(index) {
      this.$track(this.$trackMap.inspectReport.clickTab)
      this.$emit('changeTab', index)
    },
    handleTabName(name) {
      return name.length > 8 ? name.substring(0, 8) + '...' : name
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-container {
  width: 100%;
  padding-top: 0.2rem;

  background: #fff;

  .tabs {
    display: flex;

    width: 100%;

    overflow: auto;

    flex-wrap: nowrap;

    .tab {
      display: flex;

      position: relative;

      transform: translate3d(0, 0, 0);

      padding: 0 0.3rem 0.2rem 0.3rem;

      justify-content: center;
      align-items: center;

      font-size: 0.28rem;
      white-space: nowrap;
      color: #595959;

      transition: color 0.2s;

      &:after {
        position: absolute;
        right: 50%;
        bottom: 0;

        transform: translate3d(50%, 0, 0);

        width: 0rem;
        height: 0.04rem;

        background: #0daf52;

        content: '';

        transition: width 0.2s;
      }

      &.active {
        font-weight: bold;

        color: #262626;

        &:after {
          transform: translate3d(50%, 0, 0);

          width: 0.56rem;
        }
      }
    }
  }
}
</style>
